<template>
    <el-dialog title="发布产品" :visible.sync="dialogVisible" width="90%" top="5vh" @close="close">
        <div ref="dia_box" v-loading="dialogLoding" class="dia_box" @scroll="debounceHandleScroll">
            <div class="list-box">
                <div class="list-item" :class="{'active': currentList === item.refKey}" v-for="(item, index) in listData" :key="index" @click="scrollTo(item.refKey)">{{ item.label }}</div>
            </div>
            <leimu :isChakan="isChakan" :system="system" :publishInfo="publishInfo" ref="leimu"></leimu>

            <div v-if="isShowAdditionalSections">
                <images :isChakan="isChakan" :system="system" :publishInfo="publishInfo" ref="images" :areaName="areaName" :aiPower="aiPower"></images>
                <images2 v-show="isTrueEurope !== -1" :isChakan="isChakan" :system="system" :publishInfo="publishInfo"
                    ref="images2"></images2>
                <info :isChakan="isChakan" :system="system" ref="info"></info>
                <transport :isChakan="isChakan" :system="system" ref="transport"></transport>
                <variant :isChakan="isChakan" :system="system" ref="variant" :typeInfo="typeInfo" :areaName="areaName" :aiPower="aiPower"></variant>
                <attributes :isChakan="isChakan" :system="system" ref="attributes"></attributes>
            </div>
        </div>

        <!-- Footer Section -->
        <span slot="footer" style="margin-top: 60px">
            <div v-loading="isSubmit">
                    <!-- <el-button type="primary" @click="checkKeyean" style="margin-right: 10px;">检查ean</el-button> -->
                    <el-button type="primary" @click="checkKeyWord" style="margin-right: 10px;">检查关键字</el-button>
                    <el-dropdown v-if="isShowAdditionalSections" trigger="click" placement="top" @click.stop.prevent>
                    <el-button type="primary">
                        引用模板<i class="el-icon-arrow-up el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown" class="dropdown-menu">
                        <div style="max-height: 200px;overflow: auto;">
                            <el-dropdown-item v-for="(item) in templateList" :key="item.id">
                                <div class="template-item">
                                    <el-tooltip :content="item.templateName" placement="top">
                                        <span class="template-name" @click="selectTemplate(item)">
                                            {{ item.templateName }}
                                        </span>
                                    </el-tooltip>
                                    <el-button type="text" icon="el-icon-delete" @click.stop="deleteTemplate(item)"
                                        class="delete-btn"></el-button>
                                </div>
                            </el-dropdown-item>
                        </div>
                        <el-dropdown-item divided>
                            <div @click="openTemplate">另存为新模版</div>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-button class="mL-10" @click="close">取 消</el-button>
                <el-button @click="submit(1)" :loading="loadingStatus" type="primary">保 存</el-button>
                <el-button @click="submit(2)" :loading="loadingStatus" type="primary" :disabled="upIsTrue">保 存 并 发
                    布</el-button>
            </div>

        </span>
        <!-- Error Dialog -->
        <el-dialog title="校验结果-错误信息" :visible.sync="errorListVisible" width="80%" append-to-body top="5vh"
            @close="errorListVisible = false">
            <div class="error-list">
                <p v-for="(item, index) in errorList" :key="index">
                    {{ item }}
                </p>
            </div>
            <!-- {{ errorList }} -->
            <span slot="footer" style="margin-top: 60px">
                <el-button @click="errorListVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
        <el-dialog title="模版名称" :visible.sync="templateNameInputVisible" width="40%" append-to-body top="5vh"
            @close="templateNameInputVisible = false">
            <div class="information_content">
                <div class="information_input">
                    <div class="input_el input_span">
                        <el-input type="textarea" autosize class="custom-border-purple width67" v-model="templateName"
                            placeholder="请输入模版名称(必填)" show-word-limit></el-input>
                    </div>
                </div>
            </div>
            <span slot="footer" style="margin-top: 60px">
                <el-button @click="saveTemplate" type="primary">保 存</el-button>
            </span>
        </el-dialog>
        <div class="notifyBox" v-if="notifyText" :style="{transform: showNotify ? 'translateX(0)' : 'translateX(470px)',top: y + 'px'}" >
            <div class="notify-icon">
                <i :class="showNotify ? 'el-icon-arrow-right' : 'el-icon-arrow-left'" @click="showNotify = !showNotify"></i>
            </div>
            <div class="notify-content">
                <div class="notifyBox-title" @mousedown="startDrag">
                    <span>备注</span>
                </div>
                <div class="notifyBox-content">
                    {{ notifyText }}
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import leimu from "./components/leimu.vue";
import images from "./components/images.vue";
import info from "./components/info.vue";
import transport from './components/transport.vue';
import images2 from './components/safetyImages.vue';
import variant from './components/variant.vue'
import attributes from './components/attributes.vue'
import { ajaxPost, Baseurl } from '@/api/api/api'
import Ajv from "ajv";
import addFormats from "ajv-formats";
const ajv = new Ajv({ allErrors: true, strict: false }); // 关闭 strict 可以更宽容
addFormats(ajv);
export default {
    name: 'releaseDialog',
    components: {
        // 类目,图片,基本信息,运输,变体,更多属性,欧洲安全图片
        leimu,
        images,
        info,
        transport,
        variant,
        attributes,
        images2
    },
    props: {
        publishInfo: {
            type: Object,
            default: () => ({})
        },
        isChakan: {
            type: Boolean,
            default: false,
        },
        system: {
            type: Number,
            default: 5,
        },
        areaName:{
            type: String
        },
        aiPower: {},
        selectUser: {
            type: String,
            default: '',
        },
        subAccountSelect: {},
    },
    data() {
        return {
            
            currentList: '',
            // 判断类目信息中的商品类型是否为空
            leiMuShopType: null,
            loadingStatus: false,
            isTrueEurope: null,
            dialogLoding: false,
            isSubmit: false,
            upIsTrue: true,
            dialogVisible: false,
            // 基本信息动态数据处理
            info: null,
            // 属性相关信息
            typeInfo: null,
            locale: null,
            enterFormData: {},
            parent: null,
            childrens: null,
            leimuShopId: null,
            errorListVisible: false,
            templateNameInputVisible: false,
            templateName: '',
            errorList: null,
            templateList: [],
            notifyText: '',
            showNotify: false,
            dragging: false,
            offsetX: 0,
            offsetY: 0,
            x: 0,
            y: 0,
            allOf: [],
            notifyInstance: null,
            brandList: [
                "Panasonic",
                "Canon",
                "Samsung",
                "Xerox",
                "Ricoh",
                "Kyocera",
                "Pantum",
                "Konica Minolta",
                "Toshiba",
                "OKI",
                "Dell",
                "Sharp",
                "Lexmark",
                "Brother",
                "HP",
                "Epson",
                "Okidata",
                "Riso",
                "Copystar",
                "Lanier",
                "Savin",
                "Lenovo",
                "BOSE"
            ],
            keyWordMap: {
                US: "For",      // 美国
                GB: "For",      // 英国
                CA: "For",      // 加拿大
                FR: "Pour",     // 法国
                IT: "Per",      // 意大利
                JP: "for",      // 日本
                DE: "für",      // 德国
                ES: "Para",     // 西班牙
                MX: "Para",     // 墨西哥
                NL: "voor",     // 荷兰
                BR: "para",     // 巴西
                SE: "För",      // 瑞典
                PL: "Dla"       // 波兰
            },
            isCheck: false,
            removeKeyWord: {
                US: [],      // 美国
                GB: ["battery"],      // 英国
                CA: [],      // 加拿大
                FR: ["batterie"],     // 法国
                IT: ["batteria"],      // 意大利
                JP: ["バッテリー"],          // 日本
                DE: ["Batterie"],      // 德国
                ES: ["batería"],     // 西班牙
                MX: ["batería"],     // 墨西哥
                NL: ["batterij"],     // 荷兰
                BR: ["bateria"],      // 巴西
                SE: ["batteri"],      // 瑞典
                PL: ["bateria"]        // 波兰
            }
        }
    },
    created(){
        this.debounceHandleScroll = this.debounce(this.handleScroll, 100)
    },
    mounted() {
        if(localStorage.getItem('notifyY') && !isNaN(localStorage.getItem('notifyY'))){
            if(+localStorage.getItem('notifyY') > window.innerHeight - 215){
                this.y = window.innerHeight - 215;
            }else{
                this.y = isNaN(localStorage.getItem('notifyY')) ? 500 : +localStorage.getItem('notifyY');
            }
        }else{
            this.y = 500;
        }
    },
    computed: {
        isShowAdditionalSections() {
            return this.leiMuShopType !== '' && this.leiMuShopType !== ' ';
        },
        listData(){
            let result = [
                {label: '类目信息', refKey: 'leimu'},
            ];
            if(this.isShowAdditionalSections){
                result.push({label: '图片', refKey: 'images'});
                if(this.isTrueEurope !== -1){
                    result.push({label: '安全图片', refKey: 'images2'});
                }
                result.push({label: '基本信息', refKey: 'info'});
                result.push({label: '运输', refKey: 'transport'});
                result.push({label: '变体信息', refKey: 'variant'});
                result.push({label: '更多属性', refKey: 'attributes'});
            }
            return result;
        }
    },
    methods: {
        // 检查关键字
        checkKeyWord(){
            const titleText = this.insertKeywordWithHtml(this.$refs.leimu.formData.itemName, this.areaName);
            let msg = ''
            if(titleText != this.$refs.leimu.formData.itemName){
                this.$set(this.$refs.leimu.formData, 'itemName', titleText); // 说明修改了标题
                msg = '标题'
            }

            if(this.$refs.leimu.formData.titleDifferentiation){
                const titleDifferentiationText = this.insertKeywordWithHtml(this.$refs.leimu.formData.titleDifferentiation, this.areaName);
                if (titleDifferentiationText != this.$refs.leimu.formData.titleDifferentiation) {
                    this.$set(this.$refs.leimu.formData, 'titleDifferentiation', titleDifferentiationText); // 说明修改了标题
                    if(msg.length > 0){
                        msg += '，商品亮点';
                    }else{
                        msg += '商品亮点'
                    }
                }
            }

            let a = 0;
            const bluePoints = JSON.parse(JSON.stringify(this.$refs.info.bluePoints));
            bluePoints.forEach((item, index) => {
                const res = this.insertKeywordWithHtml(item, this.areaName);
                if(res != item){
                    if(!msg.includes('，亮点')){
                        msg += '，亮点第'
                    }
                    a = 1;
                    msg += `${index + 1}、`
                    this.$set(this.$refs.info.bluePoints, index, res);
                }
            })
            if(a == 1){
                msg = msg.slice(0, -1) + '行';
            }
            
            const titleList = this.$refs.info.titleList;
            let index = -1;
            for(let i = 0; i < titleList.length; i++){
                if(titleList[i]['name'] == "product_description"){
                    index = i;
                    break
                }
            }
            if(index != -1 && this.$refs.info.formData[index]){
                const desc = this.$refs.info.formData[index];
                const descRes = this.insertKeywordWithHtml(desc, this.areaName);
                if(desc != descRes){
                    msg += '，描述'
                    this.$set(this.$refs.info.formData, index, descRes);
                }
            }
            
            if(msg){
                this.$message.warning(`修改了${msg}，请检查是否正确`)
            }else{
                this.$message.success(`全部符合`)
            }

        },
        // 新增：检查EAN接口
        checkKeyean() {
            // 尝试从 info 组件中获取EAN值
            let ean = '';

            if (this.$refs.info && this.$refs.info.product_identity) {
                for (let index = 0; index < this.$refs.info.product_identity.length; index++) {
                    if (this.$refs.info.product_identity[index].name === 'externally_assigned_product_identifier') {
                        // 遍历该属性的所有子项,查找value字段
                        for (let items of this.$refs.info.topShuxingArr[index]) {
                            if (items.property === 'value' && items.publishProduct) {
                                ean = items.publishProduct;
                                break;
                            }
                        }
                        break;
                    }
                }
            }

            if (ean) {
                // 打开外部链接并携带 EAN 参数
                window.open(`https://www.barcodelookup.com/${ean}`, '_blank');
            } else {
                // 如果没填 EAN，则提示用户
                this.$message.warning('请先填写EAN码');
            }
        },
        insertKeywordWithHtml(htmlStr, country) {
            const keyword = this.keyWordMap[country];
            if (!keyword) return htmlStr;
            const removeKeywords = this.removeKeyWord[country];

            const parts = htmlStr.split(/(<[^>]+>)/g).filter(Boolean);

            const processed = parts.map(part => {
                if (/^<[^>]+>$/.test(part)) return part;

                let text = part;

                for (let brand of this.brandList) {

                    // US/GB/CA 特殊规则
                    if (["US", "GB", "CA"].includes(country)) {
                        const withRegex = new RegExp(`\\bwith\\s+(${brand})\\b`, "gi");
                        text = text.replace(withRegex, `${keyword} $1`);
                    }

                    // 全局匹配品牌
                    const brandRegex = new RegExp(`\\b(${brand})\\b`, "gi");

                    text = text.replace(brandRegex, (match, p1, offset) => {
                        // 判断匹配前是否已有关键字
                        const prefix = text.slice(Math.max(0, offset - keyword.length - 1), offset);
                        const keywordBefore = new RegExp(`\\b${keyword}\\b`, "i");
                        if (keywordBefore.test(prefix)) {
                            return match; // 前面已经有关键字，不加
                        }
                        return `${keyword} ${match}`; // 插入关键字
                    });
                }

                if(removeKeywords && removeKeywords.length > 0){
                    for (let removeKeyword of removeKeywords) {
                        // CJK字符不支持\b词边界，需区分处理
                        const hasCJK = /[\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FFF\uAC00-\uD7AF]/.test(removeKeyword);
                        const escaped = removeKeyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                        const removeRegex = hasCJK
                            ? new RegExp(escaped, "gi")
                            : new RegExp(`\\b${escaped}\\b`, "gi");
                        text = text.replace(removeRegex, "");
                    }
                    // 清理删除后残留的多余空格
                    text = text.replace(/\s{2,}/g, " ").trim();
                }

                return text;
            });

            return processed.join("");
        },
        scrollTo(refKey){
            this.currentList = refKey;
            if(this.$refs[refKey] && this.$refs[refKey].$el){   
                this.$refs[refKey].$el.scrollIntoView({behavior: 'smooth'});
            }
        },
        debounce(fn, delay = 300) {
            let timer = null;
            return function (...args) {
                if (timer) clearTimeout(timer);
                    timer = setTimeout(() => {
                    fn.apply(this, args);
                }, delay);
            };
        },

        handleScroll(){
            const containerRect = this.$refs.dia_box.getBoundingClientRect();
            const containerTop = containerRect.top;
            const containerMid = containerTop + containerRect.height / 3;
            for(let i = 0; i < this.listData.length; i++){
                if (!this.$refs[this.listData[i].refKey] || !this.$refs[this.listData[i].refKey].$el) return;
                const rect = this.$refs[this.listData[i].refKey].$el.getBoundingClientRect();
                if (rect.top <= containerMid) { //如果目标元素的位置小于等于容器上方1/3的位置，当前位置就是在目标元素位置
                    this.currentList = this.listData[i].refKey;
                }
            }
        },
        startDrag(e) {
            e.stopPropagation();
            e.preventDefault();
            this.startY = e.clientY;
            this.offsetY = this.y;
            this.isDragging = true;
            // 添加全局监听
            document.addEventListener('mousemove', this.drag);
            document.addEventListener('mouseup', this.stopDrag);
        },
        drag(e) {
            if (!this.isDragging) return;
            const delta = e.clientY - this.startY;
            this.y = +this.offsetY + +delta;
            if(this.y < 0){
                this.y = 0;
            }
        },
        stopDrag() {
            this.isDragging = false;
            localStorage.setItem('notifyY', this.y); //鼠标抬起，设置y值
            // 移除全局监听
            document.removeEventListener('mousemove', this.drag);
            document.removeEventListener('mouseup', this.stopDrag);
        },
        // 查询模版
        selectTemplateList() {
            let params = {
                productTypeName: this.$refs.leimu.formData.shopId,
                rid: JSON.parse(localStorage.getItem('role') || '{}').rid,
                countryCode: this.$parent.areaName
            }
            let API = Baseurl + 'amazonPropertyTemplate/selectAmazonPropertyTemplates'
            ajaxPost(API, params)
                .then((res) => {
                    if (res.data.code == 200) {
                        this.templateList = res.data.data
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.message,
                        })
                    }
                })
                .catch((e) => {
                    console.log(e)
                })
        },
        selectTemplate(item) {
            this.$message.success(`正在引用模板：${item.templateName}`);
            this.dialogLoding = true
            let parent = {
                attributes: JSON.parse(item.propertyTemplateValue)
            }
            this.echoDataTransport(parent, this.$refs.attributes.infoListShuxingArr, this.$refs.attributes.infoList, 'depth')
            this.echoDataTransport(parent, this.$refs.attributes.securityListShuxingArr, this.$refs.attributes.securityList)
            this.echoDataTransport(parent, this.$refs.transport.topShuxingArr, this.$refs.transport.titleList)
            setTimeout(() => {
                this.dialogLoding = false;
                this.$message.success(`模板：${item.templateName} 引用成功!`);
            }, 1000);
        },
        openNotify(message) {
            if (this.notifyInstance) {
                this.notifyInstance.close() // 关闭之前的
            }
            this.notifyInstance = this.$notify({
                title: '提示',
                message: message,
                dangerouslyUseHTMLString: true,
                duration: 0, // 设置为0，手动关闭
                type: 'warning',
                offset: 100
            })
        },

            // 手动关闭通知
        closeNotify() {
            if (this.notifyInstance) {
                this.notifyInstance.close()
                this.notifyInstance = null
            }
        },
        deleteTemplate(item) {
            this.$confirm("确定删除该模板吗？", "提示", { type: "warning" }).then(() => {
                let API = Baseurl + 'amazonPropertyTemplate/deleteAmazonPropertyTemplate'
                let params = {
                    id: item.id
                }
                ajaxPost(API, params)
                    .then((res) => {
                        if (res.data.code == 200) {
                            this.$message.success(`模板：${item.templateName} 删除成功!`);
                            this.selectTemplateList()
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.message,
                            })
                        }
                    })
                    .catch((e) => {
                        console.log(e)
                    })
            }).catch(() => { });
        },
        openTemplate() {
            this.templateNameInputVisible = true
        },
        saveTemplate() {
            let params = {
                templateName: this.templateName,
                productTypeName: this.$refs.leimu.formData.shopId,
                propertyTemplateValueJson: {},
                categoryId: this.$refs.leimu.formData.categoryId,
                rid: JSON.parse(localStorage.getItem('role') || '{}').rid,
                countryCode: this.$parent.areaName
            }
            // 基本信息-产品属性            
            this.setAttributesTransport([this.$refs.info.topShuxingArr[0]], [this.$refs.info.product_identity[0]], params.propertyTemplateValueJson)
            // 更多属性-产品详情
            this.setAttributesTransport(this.$refs.attributes.infoListShuxingArr, this.$refs.attributes.infoList, params.propertyTemplateValueJson, 'depth');
            // 更多属性-安全性和合规性
            this.setAttributesTransport(this.$refs.attributes.securityListShuxingArr, this.$refs.attributes.securityList, params.propertyTemplateValueJson);
            // 运输中的属性
            this.setAttributesTransport(this.$refs.transport.topShuxingArr, this.$refs.transport.titleList, params.propertyTemplateValueJson);
            // 删除字段
            delete params.propertyTemplateValueJson.generic_keyword;
            delete params.propertyTemplateValueJson.part_number;
            let API = Baseurl + 'amazonPropertyTemplate/createAmazonPropertyTemplate'
            ajaxPost(API, params)
                .then((res) => {
                    if (res.data.code == 200) {
                        this.$message.success(`模板：${params.templateName} 保存成功!`);
                        this.selectTemplateList()
                        this.templateNameInputVisible = false
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.message,
                        })
                    }
                })
                .catch((e) => {
                    console.log(e)
                })
        },
        close() {
            for(let k in this.$refs){
                if(this.$refs[k] && this.$refs[k].resetData){
                    this.$refs[k].resetData()
                }
            }
            this.closeNotify();
            if(this.$refs.variant){
                this.$refs.variant.variantInfo = null;
                this.$refs.variant.variantChange(this.$refs.variant.formData.radio)
            }
            if (this.leiMuShopType != ' ') {
                this.shopTypeChange()
            } else {
                this.$refs.leimu.formData.categoryName = JSON.parse(this.publishInfo.row.submitJson)[0].productType || ''
            }
            this.$nextTick(() => {
                this.dialogVisible = false;
                this.isSubmit = false;
                this.notifyText = '';
            })
        },
        PlatformClassificationChange() {
            if (this.leiMuShopType != ' ') {
                for (let index = 0; index < this.$refs.info.topShuxingArr.length; index++) {
                    const platformClassification = JSON.parse(localStorage.getItem('platformClassification'))
                    if (this.$refs.info.product_identity[index].name == "item_type_keyword" && platformClassification != null) {
                        if (platformClassification.itemType != '') {
                            this.$refs.info.topShuxingArr[index][0].publishProduct = platformClassification.itemType
                        }
                    } else if (this.$refs.info.product_identity[index].name == "recommended_browse_nodes" && platformClassification != null) {
                        this.$refs.info.topShuxingArr[index][0].publishProduct = platformClassification.nodeId
                    }
                }
            }
        },
        // 平台分类选择后
        selectPlatformClassification(value) {
            localStorage.setItem('platformClassification', JSON.stringify(value))
            this.leimuShopId = value;
            this.PlatformClassificationChange()
        },
        // 查询是否必填
        selectRequired(value) {
            // 基本信息对要点进行去除
            for (let index = 0; index < this.typeInfo.length; index++) {
                if ('bullet_point' == this.typeInfo[index].property) {
                    this.$refs.info.num = this.typeInfo[index].maxUniqueItems
                }
            }
            for (let index = 0; index < value.length; index++) {
                if (value[index] == 'bullet_point') {
                    value.splice(index, 1);
                }
            }
            let info = []
            let enumValue = null
            for (let index = 0; index < value.length; index++) {
                for (let p = 0; p < this.typeInfo.length; p++) {
                    if (value[index] == this.typeInfo[p].property) {
                        for (let o = 0; o < this.typeInfo[p].children.length; o++) {
                            if (this.typeInfo[p].children[o].property == 'value') {
                                enumValue = JSON.parse(this.typeInfo[p].children[o].enumValue)
                                if (this.typeInfo[p].children[o].enumValue != null) {
                                    for (let l = 0; l < enumValue.length; l++) {
                                        enumValue[l] = enumValue[l].toString()
                                    }
                                }
                            }
                        }
                        info.push({
                            name: this.typeInfo[p].property,
                            required: this.typeInfo[p].required,
                            titleChinese: this.typeInfo[p].titleChinese,
                            descriptionChinese: this.typeInfo[p].descriptionChinese,
                            enumValue: enumValue,
                            children: this.typeInfo[p].children
                        })
                        enumValue = null
                    }
                }
            }
            return info
        },
        // children处理
        handleChildren(value) {
            let arr = []
            for (let index = 0; index < value.length; index++) {
                arr.push([])
                for (let p = 0; p < value[index].children.length; p++) {
                    if (value[index].children[p].children.length != 0) {
                        for (let i = 0; i < value[index].children[p].children.length; i++) {
                            if (value[index].children[p].children[i].oneOf != null) {
                                value[index].children[p].children[i].oneOf = JSON.parse(value[index].children[p].children[i].oneOf)
                                value[index].children[p].children[i].oneOfValue = value[index].children[p].children[i].oneOf[0].format
                            } else {
                                value[index].children[p].children[i].oneOfValue = null
                            }
                            if (value[index].children[p].children[i].property != 'language_tag' && value[index].children[p].children[i].property != 'marketplace_id') {
                                if (value[index].children[p].children[i].enumValue != null) {
                                    value[index].children[p].children[i].enumValue = JSON.parse(value[index].children[p].children[i].enumValue)
                                    for (let obj = 0; obj < value[index].children[p].children[i].enumValue.length; obj++) {
                                        value[index].children[p].children[i].enumValue[obj] = value[index].children[p].children[i].enumValue[obj].toString()
                                    }
                                    arr[index].push(value[index].children[p].children[i])
                                    this.$set(value[index].children[p].children[i], 'publishProduct', '')
                                } else {
                                    arr[index].push(value[index].children[p].children[i])
                                    this.$set(value[index].children[p].children[i], 'publishProduct', '')
                                }
                            }
                        }
                    } else {
                        if (value[index].children[p].property != 'language_tag' && value[index].children[p].property != 'marketplace_id') {
                            if (value[index].children[p].enumValue != null) {
                                value[index].children[p].enumValue = JSON.parse(value[index].children[p].enumValue)
                                for (let obj = 0; obj < value[index].children[p].enumValue.length; obj++) {
                                    value[index].children[p].enumValue[obj] = value[index].children[p].enumValue[obj].toString()
                                }
                            }
                            if (value[index].children[p].oneOf != null) {
                                value[index].children[p].oneOf = JSON.parse(value[index].children[p].oneOf)
                                value[index].children[p].oneOfValue = value[index].children[p].oneOf[0].format
                            } else {
                                value[index].children[p].oneOfValue = null
                            }
                            arr[index].push(value[index].children[p])
                            this.$set(value[index].children[p], 'publishProduct', '')
                        }
                    }
                }
            }
            return arr
        },
        // 确认按钮                      
        async submit(value) {
            this.dialogLoding = true;
            this.isSubmit = true;
            this.closeNotify();
            // 验证描述内容长度
            if (!this.$refs.info.validateDescription()) {
                this.$message({
                    type: 'error',
                    message: '描述内容超过10000个UTF-8字节限制，无法保存!'
                });
                return;
            }
            let attributes = {}
            this.enterFormData.sellerId = this.publishInfo.sellerId
            this.enterFormData.locale = this.locale
            this.enterFormData.submitJsonArray = []
            this.enterFormData.offerJsonArray = []
            for (let index = 0; index < this.$refs.variant.tableList.length; index++) {
                this.enterFormData.offerJsonArray.push(this.$refs.variant.tableList[index].oldPurchasable_offer)
            }
            this.enterFormData.categoryId = JSON.parse(localStorage.getItem('platformClassification') || '{}').id
            // 类目信息为所有必填,构建即可
            this.enterFormData.submitJsonArray.push({
                sku: this.publishInfo.row.sku,
                operationType: this.parent.operationType,
                productType: this.$refs.leimu.formData.shopId,
                requirements: this.parent.requirements
            })
            // 亮点
            attributes.bullet_point = []
            for (let index = 0; index < this.$refs.info.bluePoints.length; index++) {
                attributes.bullet_point.push({
                    value: this.$refs.info.bluePoints[index],
                    language_tag: this.locale,
                    marketplace_id: this.publishInfo.row.marketplaceId
                })
            }
            // 描述
            attributes.product_description = [{
                value: this.$refs.info.formData[0],
                language_tag: this.locale,
                marketplace_id: this.publishInfo.row.marketplaceId
            }]
            // 关键词
            attributes.generic_keyword = [{
                value: this.$refs.info.formData[1],
                language_tag: this.locale,
                marketplace_id: this.publishInfo.row.marketplaceId
            }]
            // 基本信息-产品属性
            this.setAttributesTransport(this.$refs.info.topShuxingArr, this.$refs.info.product_identity, attributes)

            // 运输
            this.setAttributesTransport(this.$refs.transport.topShuxingArr, this.$refs.transport.titleList, attributes, 'length');

            // 更多属性-产品详情
            this.setAttributesTransport(this.$refs.attributes.infoListShuxingArr, this.$refs.attributes.infoList, attributes, 'depth');

            // 更多属性-安全性和合规性
            this.setAttributesTransport(this.$refs.attributes.securityListShuxingArr, this.$refs.attributes.securityList, attributes);

            // 变体信息
            this.setAttributesTransport(this.$refs.variant.oneTopShuxingArr, this.$refs.variant.topShuxingArr, attributes);

            let imageLocators = null;
            let imageObj = {}
            if (this.isTrueEurope != -1) {
                for (let index = 0; index < this.$refs.images2.imageList.length; index++) {
                    imageLocators = this.$refs.images2.imageList[index]
                    imageObj.marketplace_id = this.publishInfo.row.marketplaceId
                    if (this.$refs.images2.fileList[imageLocators] && this.$refs.images2.fileList[imageLocators].length >= 1) {
                        imageObj.media_location = this.$refs.images2.fileList[imageLocators][0].url
                        attributes[imageLocators] = [{ ...imageObj }]
                    }
                }
            }
            var oldAttributes = { ...attributes };
            attributes.item_name = [{
                value: this.$refs.leimu.formData.itemName,
                language_tag: this.locale,
                marketplace_id: this.publishInfo.row.marketplaceId
            }]
            if(this.$refs.leimu.formData.titleDifferentiation){
                attributes.title_differentiation = [{
                    value: this.$refs.leimu.formData.titleDifferentiation,
                    language_tag: this.locale,
                    marketplace_id: this.publishInfo.row.marketplaceId
                }]
            }
            
            // 图片信息处理
            for (let index = 0; index < this.$refs.images.imageList.length; index++) {
                imageLocators = this.$refs.images.imageList[index]
                imageObj.marketplace_id = this.publishInfo.row.marketplaceId
                if (this.$refs.images.fileList[imageLocators] && this.$refs.images.fileList[imageLocators].length >= 1) {
                    imageObj.media_location = this.$refs.images.fileList[imageLocators][0].url
                    attributes[imageLocators] = [{ ...imageObj }]
                }
            }
            const allPromise = [];
            // 变体信息-判断是否为变体
            if (this.$refs.variant.formData.radio == 'one') {
                this.enterFormData.submitJsonArray[0].attributes = attributes
                this.enterFormData.offerJsonArray = [this.$refs.variant.purchasable_offer];
                if (this.$refs.variant.purchasable_offer != undefined) {
                    attributes.purchasable_offer = [this.$refs.variant.generateJsonData(this.$refs.variant.purchasable_offer)]
                    attributes.purchasable_offer.marketplace_id = this.publishInfo.row.marketplaceId
                }
            } else {
                if(this.$refs.variant.tableList.length === 0){
                    this.$message.error('请添加变体信息');
                    return;
                }
                this.$nextTick(async () => {
                    attributes.variation_theme = [{
                        name: this.$refs.variant.formData.bianti
                    }]
                    attributes.parentage_level = [{
                        value: "parent",
                        marketplace_id: this.publishInfo.row.marketplaceId
                    }]
                    attributes.child_parent_sku_relationship = [{
                        child_relationship_type: "variation",
                        marketplace_id: this.publishInfo.row.marketplaceId
                    }]
                    // 描述
                    attributes.product_description = [{
                        value: this.$refs.info.formData[0],
                        language_tag: this.locale,
                        marketplace_id: this.publishInfo.row.marketplaceId
                    }]
                    // 关键词
                    attributes.generic_keyword = [{
                        value: this.$refs.info.formData[1],
                        language_tag: this.locale,
                        marketplace_id: this.publishInfo.row.marketplaceId
                    }]
                    this.enterFormData.submitJsonArray[0].attributes = attributes;
                    
                    for (let index = 0; index < this.$refs.variant.tableList.length; index++) {
                        // 克隆一份新的 attributes 对象
                        let newAttributes = { ...oldAttributes };
                        newAttributes.purchasable_offer = this.$refs.variant.tableList[index].purchasable_offer_data;
                        newAttributes.purchasable_offer[0].marketplace_id = this.publishInfo.row.marketplaceId
                        if (this.$refs.variant.tableList[index].fulfillment_availability != undefined) { //变体履行可用性
                            newAttributes.fulfillment_availability = [this.$refs.variant.tableList[index].fulfillment_availability];
                        }
                        if (this.$refs.variant.tableList[index].list_price != undefined) { //变体价格
                            newAttributes.list_price = [this.$refs.variant.tableList[index].list_price];
                        }
                        const sku = this.$refs.variant.tableList[index].SKU;
                        if(this.subAccountSelect.length > 0){
                            // 说明是多账号
                            let keywords = '';
                            for(let z = 0; z < this.subAccountSelect.length; z++){
                                if(this.subAccountSelect[z].uid == this.selectUser){
                                    keywords = this.subAccountSelect[z].keywords;
                                    break;
                                }
                            }
                            if(!keywords){
                                this.$message.error("请关闭弹窗，选择正确的账号后重新发布");
                                this.dialogLoding = false;
                                this.isSubmit = false;
                                return;
                            }
                            const arr1 = sku.split('-');
                            if(arr1[arr1.length - 1].trim() == keywords){
                                // 说明已经有后缀了，不用再加
                                // keywords = '';
                            }else{
                                this.$set(this.$refs.variant.tableList[index], "SKU", sku + '-' + keywords)
                            }
                        }
                        const pro = this.$refs.variant.validateRowData(this.$refs.variant.tableList[index]);
                        allPromise.push(pro);
                        // 图片信息处理
                        let imageLocators = null;
                        let imageObj = {}
                        for (let i = 0; i < this.$refs.variant.tableList[index].imageList.length; i++) {
                            imageLocators = this.$refs.variant.tableList[index].imageList[i].name
                            imageObj.marketplace_id = this.publishInfo.row.marketplaceId
                            imageObj.media_location = this.$refs.variant.tableList[index].imageList[i].url
                            newAttributes[imageLocators] = [{ ...imageObj }]
                        }
                        newAttributes.parentage_level = [{
                            value: "child",
                            marketplace_id: this.publishInfo.row.marketplaceId
                        }]

                        // 描述
                        newAttributes.product_description = [{
                            value: this.$refs.info.formData[0],
                            language_tag: this.locale,
                            marketplace_id: this.publishInfo.row.marketplaceId
                        }]
                        // 关键词
                        newAttributes.generic_keyword = [{
                            value: this.$refs.info.formData[1],
                            language_tag: this.locale,
                            marketplace_id: this.publishInfo.row.marketplaceId
                        }]

                        newAttributes.variation_theme = [{
                            name: this.$refs.variant.formData.bianti
                        }]
                        newAttributes.externally_assigned_product_identifier = [{
                            type: this.$refs.variant.tableList[index].shopType,
                            value: this.$refs.variant.tableList[index].shopId,
                            marketplace_id: this.publishInfo.row.marketplaceId
                        }]
                        newAttributes.number_of_items = [{
                            value: parseInt(this.$refs.variant.tableList[index].numberItem),
                            marketplace_id: this.publishInfo.row.marketplaceId
                        }]
                        newAttributes.child_parent_sku_relationship = [{
                            parent_sku: this.publishInfo.row.sku,
                            child_relationship_type: "variation",
                            marketplace_id: this.publishInfo.row.marketplaceId
                        }]
                        let locator = null;
                        let bianTi = this.$refs.variant.formData.bianti.split('/');
                        for (let i = 0; i < bianTi.length; i++) {
                            newAttributes.item_name = [{
                                value: this.$refs.leimu.formData.itemName + ' ' + this.$refs.variant.tableList[index][bianTi[i]],
                                language_tag: this.locale,
                                marketplace_id: this.publishInfo.row.marketplaceId
                            }]
                            if(this.$refs.leimu.formData.titleDifferentiation){
                                newAttributes.title_differentiation = [{
                                    value: this.$refs.leimu.formData.titleDifferentiation,
                                    language_tag: this.locale,
                                    marketplace_id: this.publishInfo.row.marketplaceId
                                }]
                            }

                            locator = bianTi[i].toLowerCase();
                            newAttributes[locator] = [
                                {
                                    value: this.$refs.variant.tableList[index][bianTi[i]],
                                    marketplace_id: this.publishInfo.row.marketplaceId,
                                    language_tag: this.locale
                                }
                            ];
                        }
                        this.enterFormData.submitJsonArray.push({
                            sku: this.$refs.variant.tableList[index].SKU,
                            operationType: this.parent.operationType,
                            productType: this.$refs.leimu.formData.shopId,
                            requirements: this.parent.requirements,
                            attributes: newAttributes
                        });
                    }
                });
            }
            if(this.$refs.variant.formData.radio == 'two'){
                const res = await this.$refs.variant.validateData(); //验证变体信息
                if(!res){
                    this.dialogLoding = false;
                    this.isSubmit = false;
                    return;
                }
                const res1 = await Promise.allSettled(allPromise); //校验每一行的可购买优惠
                const errorMsg = [];
                for(let index = 0; index < res1.length; index++){
                    if(res1[index].status === 'rejected'){
                        errorMsg.push('第' + (index + 1) + '行校验失败：' + res1[index].reason.msg);
                    }
                }
                if(errorMsg.length > 0){
                    this.dialogLoding = false;
                    this.isSubmit = false;
                    errorMsg.unshift('请检查变体信息');
                    this.$message({
                        dangerouslyUseHTMLString: true,
                        message: errorMsg.map((item, index) => {
                            let style = 'margin-bottom: 10px;';
                            if(index === errorMsg.length - 1){
                                style = '';
                            }
                            return `<div style="${style}">${item}</div>`
                        }).join(''),
                        type: 'error'
                    });
                    return;
                }
            }
            
            this.enterFormData.id = this.publishInfo.row.listingId;
            const arr = this.enterFormData.submitJsonArray;
            let missingProperty = [];
            for(let index = 0; index < arr.length; index++){
                const res1 = this.validateRequiredFields(arr[index].attributes, this.allOf)
                if(res1.missingFields.length > 0){
                    missingProperty.push(...res1.missingFields);
                }
            }
            if(missingProperty.length > 0){
                this.openNotify(['建议填写属性：', ...new Set(missingProperty)].map(item => `<p >${item}</p>`).join(''));
            }
            // 可购买优惠
            if (value == 1) {
                let API = Baseurl + 'amazonProductListing/updateAmazonProductListings'
                ajaxPost(API, this.enterFormData)
                    .then((res) => {
                        this.dialogLoding = false;
                        this.isSubmit = false;
                        if (res.data.code == 200) {
                            if (res.data.data.errorList) { //校验失败，弹窗不关闭
                                this.errorListVisible = true
                                this.errorList = res.data.data.errorList
                                sessionStorage.removeItem('list_priceNum')
                            } else {
                                if(missingProperty.length > 0){ //有缺失属性，弹窗不关闭

                                }else{
                                    this.dialogVisible = false;
                                }
                                this.notifyText = '';
                                let updateProductByProductNumberAndArea = {}
                                this.$set(updateProductByProductNumberAndArea, 'productNumber', this.publishInfo.row.productNumber)
                                this.$set(updateProductByProductNumberAndArea, 'areaName', this.publishInfo.row.areaName)
                                this.$set(updateProductByProductNumberAndArea, 'title', this.enterFormData.submitJsonArray[0].attributes.item_name[0].value)
                                if(this.enterFormData.submitJsonArray[0].attributes.title_differentiation && this.enterFormData.submitJsonArray[0].attributes.title_differentiation.length > 0){
                                    this.$set(updateProductByProductNumberAndArea, 'titleDifferentiation', this.enterFormData.submitJsonArray[0].attributes.title_differentiation[0].value)
                                }
                                const oldArray = this.enterFormData.submitJsonArray[0].attributes.bullet_point;
                                const newArray = oldArray.map(item => `${item.value}`)  
                                this.$set(updateProductByProductNumberAndArea, 'bluePoints', newArray)
                                this.$set(updateProductByProductNumberAndArea, 'keyword', this.enterFormData.submitJsonArray[0].attributes.generic_keyword[0].value)
                                this.$set(updateProductByProductNumberAndArea, 'briefIntroduction', this.enterFormData.submitJsonArray[0].attributes.product_description[0].value)
                                API = Baseurl + 'amazonProductListing/updateProductByProductNumberAndArea'
                                ajaxPost(API, updateProductByProductNumberAndArea)
                                    .then((res) => {
                                        if (res.data.code == 200) {
                                            this.$message({
                                                type: 'success',
                                                message: '修改成功!',
                                            })
                                            this.$parent.serach(this.$parent.currentPage4)
                                            this.$refs.leimu.formData.categoryName = ''
                                        } else {
                                            this.$message({
                                                type: 'error',
                                                message: res.data.message,
                                            })
                                        }
                                    })
                                    .catch((e) => {
                                        console.error(e)
                                    })
                            }
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.message,
                            })
                        }
                    })
                    .catch((e) => {
                        this.dialogLoding = false;
                        this.isSubmit = false;
                        console.error(e)
                    })
            } else {
                this.enterFormData.productId = this.publishInfo.row.id
                this.enterFormData.rid = JSON.parse(localStorage.getItem('role') || '{}').rid
                let API = Baseurl + 'amazonProductListing/updateAndReleaseAmazonProductListing'
                ajaxPost(API, this.enterFormData)
                    .then((res) => {
                        this.dialogLoding = false;
                        this.isSubmit = false;
                        if (res.data.code == 200) {
                            this.dialogVisible = false;
                            this.notifyText = '';
                            sessionStorage.removeItem('list_priceNum')
                            this.$parent.serach(this.$parent.currentPage4)
                            this.enterFormData.productId = null
                            this.$refs.leimu.formData.categoryName = ''
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.message,
                            })
                        }
                    })
                    .catch((e) => {
                        this.dialogLoding = false;
                        this.isSubmit = false;
                        console.log(e)
                    })
            }
        },
        // 构建attributes A=输入的内容 B=文字内容 C=attributes
        setAttributes(a, b, c) {
            let locators = null;
            let childrenLocators = null;
            let obj = {}
            let isTrue = false
            for (let index = 0; index < a.length; index++) {
                locators = b[index].name
                isTrue = false
                for (let p = 0; p < b[index].children.length; p++) {
                    childrenLocators = b[index].children[p]
                    if (childrenLocators.property == 'language_tag') {
                        obj[childrenLocators.property] = this.locale
                    } else if (childrenLocators.property == 'marketplace_id') {
                        obj[childrenLocators.property] = this.publishInfo.row.marketplaceId
                    } else {
                        if (b[index].children[p].publishProduct == '' || b[index].children[p].publishProduct == undefined || b[index].children[p].publishProduct == 'undefined') {
                            isTrue = true
                        } else {
                            obj[childrenLocators.property] = this.convertValue(b[index].children[p].publishProduct, childrenLocators.type)
                            isTrue = false
                        }
                    }
                }
                if (locators == 'fulfillment_availability') {
                    isTrue = false
                }
                if (isTrue != true) {
                    c[locators] = [{ ...obj }]
                }
                obj = {}
            }
        },
        // 转换类型
        convertValue(value, type) {
            switch (type) {
                case 'string':
                    return String(value);
                case 'boolean':
                    if (value == 'true' || value == true) {
                        return true;
                    } else if (value == 'false' || value == false) {
                        return false;
                    }
                    return Boolean(value);
                case 'integer':
                    return parseInt(value, 10);
                case 'number':
                    return parseFloat(value);
                case 'array':
                    if (value === null || value === undefined) return [''];
                    return Array.isArray(value) ? value : [value];
                default:
                    return value;
            }
        },
        // setAttributesTransport(a, b, c, d) {
        //     let locators = null;
        //     let childrenLocators = null;
        //     let obj = {};
        //     let isTrue = false;
        //     let childrenProperty = null;
        //     for (let index = 0; index < a.length; index++) {
        //         locators = b[index].name
        //         for (let p = 0; p < b[index].children.length; p++) {
        //             childrenLocators = b[index].children[p]
        //             if (childrenLocators.property == 'language_tag') {
        //                 obj[childrenLocators.property] = this.locale
        //             } else if (childrenLocators.property == 'marketplace_id') {
        //                 obj[childrenLocators.property] = this.publishInfo.row.marketplaceId
        //             } else {
        //                 if (childrenLocators.property == d || childrenLocators.property == 'width' || childrenLocators.property == 'height') {
        //                     if (b[index].children[p].children.length > 1) {
        //                         obj[childrenLocators.property] = {}
        //                         for (let q = 0; q < b[index].children[p].children.length; q++) {
        //                             childrenProperty = b[index].children[p].children[q].property
        //                             obj[childrenLocators.property][childrenProperty] = this.convertValue(b[index].children[p].children[q].publishProduct, b[index].children[p].children[q].type)
        //                             if (b[index].children[p].children[q].publishProduct == '' || b[index].children[p].children[q].publishProduct == undefined || b[index].children[p].children[q].publishProduct == null) {
        //                                 isTrue = true
        //                                 continue
        //                             } else {
        //                                 isTrue = false
        //                             }
        //                         }
        //                     }
        //                 } else {
        //                     obj[childrenLocators.property] = this.convertValue(b[index].children[p].publishProduct, childrenLocators.type)
        //                     if (b[index].children[p].publishProduct == '' || b[index].children[p].publishProduct == undefined || b[index].children[p].publishProduct == null) {
        //                         isTrue = true
        //                         continue
        //                     } else {
        //                         isTrue = false
        //                     }
        //                 }
        //             }
        //         }
        //         if (locators == 'color') {
        //             isTrue = false
        //         }
        //         if (!isTrue) {
        //             c[locators] = [{ ...obj }]
        //         }
        //         obj = {}
        //     }
        // },

        setAttributesTransport(a, b, c, d) {
            let locators = null;
            for (let index = 0; index < a.length; index++) {
                locators = b[index].name; //第一层的key值，frame、"material"...
                const rowResult = {}; //每一项的数据，生成frame: [{}]格式
                let hasData = false;
                for (let p = 0; p < b[index].children.length; p++) {
                    const childrenLocators = b[index].children[p];
                    const type1 = childrenLocators.type;
                    if(type1 == 'array'){
                        rowResult[childrenLocators.property] = [{}];
                    }else if(type1 == 'object'){
                        rowResult[childrenLocators.property] = {};
                    }

                    if (childrenLocators.children.length > 0) { //有子项，循环拿到数据
                        for (let q = 0; q < childrenLocators.children.length; q++) {
                            const childrenProperty = childrenLocators.children[q].property; //key
                            let value = childrenLocators.children[q].publishProduct; //value
                            if(childrenProperty == 'language_tag'){
                                value = this.locale;
                            }else if (childrenProperty == 'marketplace_id'){
                                value = this.publishInfo.row.marketplaceId;
                            } else{ //根据格式调整数据
                                if(value === undefined || value === '' || value === null){
                                    continue
                                }
                                value = this.convertValue(value, childrenLocators.children[q].type)
                            }
                            if (value === '' || value === undefined || value === 'undefined' || value === null || value === 'null' || (childrenLocators.children[q].type == 'number' && isNaN(value)) || (childrenLocators.children[q].type == 'integer' && isNaN(value))) { //没有数据跳过
                                continue
                            }
                            

                            // 条件1：value不等于两个特殊值（locale和marketplaceId）
                            const isNotSpecialValues = value !== this.locale && value !== this.publishInfo.row.marketplaceId;

                            // 条件2：是数组且非空（长度>0）
                            const isNonEmptyArray = Array.isArray(value) && value.length > 0;

                            // 条件3：是纯对象且非空（有自有属性）
                            const isNonEmptyObject = Object.prototype.toString.call(value) === '[object Object]' && Object.keys(value).length > 0;

                            // 最终判断：必须满足“不是特殊值”，且同时“不是空数组/空对象”，且“是有效数据（非空数组/非空对象或其他非特殊值）”
                            if (isNotSpecialValues && (isNonEmptyArray || isNonEmptyObject || 
                                // 非数组/非对象的普通值（如字符串、数字等，且已通过isNotSpecialValues）
                                !(Array.isArray(value) || Object.prototype.toString.call(value) === '[object Object]')
                                )
                            ) {
                                hasData = true;
                            }
                            if(type1 == 'array'){
                                rowResult[childrenLocators.property][0][childrenProperty] = value;
                            }else if(type1 == 'object'){
                                rowResult[childrenLocators.property][childrenProperty] = value;
                            }else{
                                rowResult[childrenLocators.property] = value;
                            }
                        }
                    }else {
                        let value = childrenLocators.publishProduct;
                        if(childrenLocators.property == 'language_tag'){
                            value = this.locale;
                        }else if(childrenLocators.property == 'marketplace_id'){
                            value = this.publishInfo.row.marketplaceId;
                        }else{ //根据格式调整数据
                            if(value === undefined || value === '' || value === null){
                                continue
                            }
                            value = this.convertValue(value, childrenLocators.type);
                        }
                        if (value === '' || value === undefined || value === 'undefined' || value === null || value === 'null' || (childrenLocators.type == 'number' && isNaN(value)) || (childrenLocators.type == 'integer' && isNaN(value))) { //没有数据跳过
                            continue
                        }
                        
                        // 条件1：value不等于两个特殊值（locale和marketplaceId）
                        const isNotSpecialValues = value !== this.locale && value !== this.publishInfo.row.marketplaceId;

                        // 条件2：是数组且非空（长度>0）
                        const isNonEmptyArray = Array.isArray(value) && value.length > 0;

                        // 条件3：是纯对象且非空（有自有属性）
                        const isNonEmptyObject = Object.prototype.toString.call(value) === '[object Object]' && Object.keys(value).length > 0;

                        // 最终判断：必须满足“不是特殊值”，且同时“不是空数组/空对象”，且“是有效数据（非空数组/非空对象或其他非特殊值）”
                        if (isNotSpecialValues && (isNonEmptyArray || isNonEmptyObject || 
                            // 非数组/非对象的普通值（如字符串、数字等，且已通过isNotSpecialValues）
                            !(Array.isArray(value) || Object.prototype.toString.call(value) === '[object Object]')
                            )
                        ) {
                            hasData = true;
                        }
                        rowResult[childrenLocators.property] = value;
                    }
                }
                if (hasData) {
                    c[locators] = [{ ...rowResult }]
                }
            }
        },
        // 查询变体主题
        getVariantTitle() {
            for (let index = 0; index < this.typeInfo.length; index++) {
                if (this.typeInfo[index].property == "variation_theme") {
                    this.$refs.variant.options = JSON.parse(this.typeInfo[index].children[0].enumValue)
                }
            }
        },
        // 回显数据 A=回显的内容 B=输入的内容 C=文字内容
        echoDataTransport(a, b, c, d) {
            let locators = null;
            let positionText = null;
            let data = []
            let childrenLocators = null;
            for (let index = 0; index < c.length; index++) {
                const locators = c[index].name;
                if (a.attributes[locators] != undefined) {
                    let data = a.attributes[locators][0];
                   
                    for (let i = 0; i < c[index].children.length; i++) { //每条数据都有
                        const type1 = c[index].children[i]['type'];
                        const property = c[index].children[i]['property']; //color

                        if(c[index].children[i]['children'].length > 0){ //进入的说明都是数组或者对象
                            for(let z = 0; z < b[index].length; z++){ //找到子项
                                // if(b[index][z]['title'] && b[index][z]['title'] == c[index].children[i]['title']){ //找到相同的一项
                                    for(let j = 0; j < c[index].children[i]['children'].length; j++){ //循环子项，如color：['value', 'unit']等
                                        if(b[index][z]['title'] == c[index].children[i]['children'][j]['title'] && b[index][z]['property'] == c[index].children[i]['children'][j]['property']){
                                            let d1 = data[property];
                                            if(type1 == 'array'){
                                                d1 = data[property][0];
                                            }
                                            
                                            b[index][z]['publishProduct'] = d1[b[index][z]['property']];
                                        }
                                    }
                                // }
                            }
                        }else{
                            // \
                            for(let z = 0; z < b[index].length; z++){
                                if(b[index][z]['title'] && b[index][z]['title'] == c[index].children[i]['title']){//找到相同的一项
                                    b[index][z]['publishProduct'] = data[b[index][z]['property']];
                                } 
                            }
                        }
                    }
                }


                // if (locators == 'item_depth_width_height' || locators == 'item_package_dimensions') {
                //     if (a.attributes[locators] != undefined && locators == c[index].name) {
                //         for (let i = 0; i < c[index].children.length; i++) {
                //             if (c[index].children[i].property == d || c[index].children[i].property == 'width' || c[index].children[i].property == 'height') {
                //                 childrenLocators = c[index].children[i].property
                //                 for (let width = 0; width < c[index].children[i].children.length; width++) {
                //                     data.push(a.attributes[locators][0][childrenLocators][c[index].children[i].children[width].property])
                //                 }
                //             }
                //         }
                //         for (let p = 0; p < b[index].length; p++) {
                //             b[index][p].publishProduct = data[p]
                //         }
                //     }
                // } else {
                //     if (a.attributes[locators] != undefined && locators == c[index].name) {
                //         for (let i = 0; i < b[index].length; i++) {
                //             positionText = b[index][i].property
                //             b[index][i].publishProduct = a.attributes[locators][0][positionText]
                //         }
                //     }
                // }
            }
        },
        echoData(a, b, c) {
            let locators = null;
            let positionText = null;
            for (let index = 0; index < c.length; index++) {
                locators = c[index].name
                if (a.attributes[locators] != undefined && locators == c[index].name) {
                    for (let i = 0; i < b[index].length; i++) {
                        positionText = b[index][i].property
                        b[index][i].publishProduct = a.attributes[locators][0][positionText]
                    }
                }
            }
        },
        // 回显图片数据
        setEchoImageData() {
            let locators = null;
            const fileList = {};
            for (let index = 0; index < this.$refs.images.imageList.length; index++) {
                locators = this.$refs.images.imageList[index]
                if (this.parent.attributes[locators] != undefined && locators == this.$refs.images.imageList[index]) {
                    fileList[locators] = []
                    fileList[locators].push({
                        name: locators,
                        url: this.parent.attributes[locators][0].media_location
                    })
                    this.$refs.images.hideUpload[index] = true
                }
            }
            this.$refs.images.fileList = fileList;
            if (this.isTrueEurope != -1) {
                for (let i = 0; i < this.$refs.images2.imageList.length; i++) {
                    locators = this.$refs.images2.imageList[i]
                    if (this.parent.attributes[locators] != undefined && locators == this.$refs.images2.imageList[i]) {
                        this.$set(this.$refs.images2.fileList, locators, [{
                            name: locators,
                            url: this.parent.attributes[locators][0].media_location
                        }])
                        // this.$refs.images2.fileList[locators] = []
                        // this.$refs.images2.fileList[locators].push({
                        //     name: locators,
                        //     url: this.parent.attributes[locators][0].media_location
                        // })
                        this.$set(this.$refs.images2.hideUpload, i, true)
                        //
                        // this.$refs.images2.hideUpload[i] = true
                    }
                }
            }
        },
        // 设置基本信息必填
        setEchoInfoData() {
            if (this.parent.attributes.bullet_point != undefined) {
                for (let index = 0; index < this.parent.attributes.bullet_point.length; index++) {
                    this.$refs.info.bluePoints[index] = this.parent.attributes.bullet_point[index].value
                }
            }
            if (this.parent.attributes.product_description != undefined) {
                this.$refs.info.formData[0] = this.parent.attributes.product_description[0].value
            }
            if (this.parent.attributes.generic_keyword != undefined) {
                this.$refs.info.formData[1] = this.parent.attributes.generic_keyword[0].value
            }
        },
        // 数据处理
        generateJsonData(schema) {
            // 遍历当前层级的所有字段
            schema.children.forEach(child => {
                // 递归处理子字段
                if (child.children && child.children.length > 0) {
                    this.generateJsonData(child);  // 对于有 children 的字段进行递归
                } else {
                    // 根据类型生成对应的值
                    // 确保在DOM更新后执行
                    if (child.enumValue != null) {
                        child.enumValue = JSON.parse(child.enumValue);
                    }
                    if (child.oneOf != null) {
                        child.oneOf = JSON.parse(child.oneOf);
                        child.oneOfValue = child.oneOf[0].format;
                    }
                }
            });
            return schema
        },
        // 商品类型变更
        shopTypeChange() {
            if (this.leiMuShopType != ' ') {
                // 运输信息
                this.$refs.transport.titleList = []
                this.$refs.transport.topShuxingArr = []
                // 变体信息-Sku
                this.$refs.variant.formData.Sku = null
                this.$refs.variant.topShuxingArr = []
                this.$refs.variant.oneTopShuxingArr = []
                this.$refs.variant.imageList = []
                this.$refs.variant.tableList = []
                // 更多属性-各页
                this.$refs.attributes.infoList = this.info
                this.$refs.attributes.infoListShuxingArr = []
                this.$refs.attributes.securityList = []
                this.$refs.attributes.securityListShuxingArr = []
                // 基本信息-产品属性
                this.$refs.info.product_identity = []
                this.$refs.info.topShuxingArr = []
                // 图片信息
                this.$refs.images.imageList = []
                this.$refs.images.imageText = []
                let locators = null;
                for (let index = 0; index < this.$refs.images.imageList.length; index++) {
                    locators = this.$refs.images.imageList[index]
                    this.$refs.images.fileList[locators] = []
                    this.$refs.images.hideUpload[index] = false
                }
                this.$refs.images2.imageList = []
                this.$refs.images2.imageText = []
                for (let index = 0; index < this.$refs.images2.imageList.length; index++) {
                    locators = this.$refs.images2.imageList[index]
                    this.$refs.images2.fileList[locators] = []
                    this.$refs.images2.hideUpload[index] = false
                }
            }
        },
        /**
         * 构建一个完整的 JSON Schema，并验证数据
         * @param {Object} data 你的表单或数据对象
         * @param {Array} rules JSON schema 条件规则数组（即你上传的 1.json）
         * @returns {Array} 缺失的字段列表
         */
        validateRequiredFields(data, rules) {
            // 把 rules 转成一整个 schema（AJV 要一个完整 schema）
            const fullSchema = {
                type: "object",
                properties: {},
                allOf: rules
            };
            
            const validate = ajv.compile(fullSchema);
            const valid = validate(data);

            const missingFields = [];
            const invalidFields = {};

            if (!valid && Array.isArray(validate.errors)) {
                for (const err of validate.errors) {
                    // 处理缺失字段
                    if (err.keyword === "required") {
                        const prop = err.params.missingProperty;
                        const path = err.instancePath ? `${err.instancePath.replace(/^\//, "").replace(/\//g, ".")}.${prop}` : prop;
                        missingFields.push(path);
                    } else {
                        // 非法字段（比如类型不对、格式不对、值不合法等）
                        const path = err.instancePath.replace(/^\//, "").replace(/\//g, ".");
                        invalidFields[path] = err.message;
                    }
                }
            }
            return {
                missingFields: [...new Set(missingFields)].filter(item => item !== "merchant_shipping_group"),
                invalidFields
            }
        },
        deepDeduplicate(obj) {
            if (Array.isArray(obj)) {
                // 判断是否是最底层（数组中不再嵌套对象或数组）
                const isPrimitiveArray = obj.every(item => typeof item !== 'object' || item === null);
                if (isPrimitiveArray) {
                    // 最底层，进行去重
                    return Array.from(new Set(obj));
                } else {
                    // 继续递归处理数组中的每一项
                    return obj.map(item => this.deepDeduplicate(item));
                }
            } else if (typeof obj === 'object' && obj !== null) {
                const result = {};
                for (const key in obj) {
                    result[key] = this.deepDeduplicate(obj[key]);
                }
                return result;
            } else {
                // 原始值不处理
                return obj;
            }
        },
        // 打开弹窗
        openDialog(item, number) {
            this.isTrueEurope = -1;
            let paramsData = null;
            if (number == 1) {
                paramsData = {
                    marketplaceId: item.row.marketplaceId,
                    productType: JSON.parse(item.row.submitJson)[0].productType
                }
                this.$nextTick(() => {
                    this.leiMuShopType = JSON.parse(item.row.submitJson)[0].productType || ' '
                })
            } else {
                paramsData = {
                    marketplaceId: item.row.marketplaceId,
                    productType: this.$refs.leimu.formData.shopId
                }
                this.$nextTick(() => {
                    this.leiMuShopType = paramsData.productType || ' '
                })
            }
            this.$nextTick(() => {
                this.enterFormData.marketplaceId = item.row.marketplaceId
                this.dialogLoding = true
                this.dialogVisible = true
            })
            let API = null;
            API = Baseurl + 'amazonProductTypeDefinitionSchema/amazonProductTypeDefinitionSchemas'
            ajaxPost(API, paramsData)
                .then((res) => {
                    if (res.data.code == 200) {
                        if (this.publishInfo.variant == undefined) {
                            this.$refs.leimu.formData.itemName = this.publishInfo.row.title
                            this.$refs.leimu.formData.titleDifferentiation = this.publishInfo.row.titleDifferentiation
                        } else {
                            this.$refs.leimu.formData.itemName = this.publishInfo.variant.attributes.item_name[0].value
                            if(this.publishInfo.variant.attributes.title_differentiation && this.publishInfo.variant.attributes.title_differentiation.length > 0){
                                this.$refs.leimu.formData.titleDifferentiation = this.publishInfo.variant.attributes.title_differentiation[0].value
                            }
                        }
                        this.$refs.leimu.areaName = this.publishInfo.row.areaName
                        if (number == 1) {
                            this.$refs.leimu.formData.shopId = JSON.parse(this.publishInfo.row.submitJson)[0].productType || ''
                        } else {
                            this.$refs.leimu.formData.shopId = this.$refs.leimu.formData.shopId
                        }
                        if (res.data.data.length != 0) {
                            this.typeInfo = res.data.data[0].children;
                            this.allOf = this.deepDeduplicate(JSON.parse(res.data.data[0].allOf));
                            API = Baseurl + 'amazonProductTypeDefinitionSchema/amazonProductTypeDefinition'
                            ajaxPost(API, paramsData)
                                .then((resp) => {
                                    if (resp.data.code == 200) {
                                        if (this.leiMuShopType != ' ') {
                                            let two = [];
                                            const submitJson = JSON.parse(this.publishInfo.row.submitJson);
                                            for (let index = 0; index < submitJson.length; index++) {
                                                if (submitJson[index].attributes.parentage_level != undefined) {
                                                    if (submitJson[index].attributes.parentage_level[0].value == 'parent') {
                                                        this.parent = submitJson[index]
                                                    } else {
                                                        two.push(submitJson[index])
                                                        this.$refs.variant.variantInfo = two
                                                    }
                                                } else {
                                                    this.parent = submitJson[index]
                                                }
                                            }
                                            if (this.publishInfo.row.checkStatus == 1) {
                                                this.upIsTrue = false
                                            }
                                            this.notifyText = item.row.remarks;
                                            this.showNotify = true;
                                            this.$nextTick(() => {
                                                this.$refs.images.imgSelectList = this.publishInfo.row.productImgUrls
                                                this.$refs.variant.imgSelectList = this.publishInfo.row.productImgUrls
                                                
                                                if(this.aiPower){
                                                    const arr = (this.aiPower + '').split(',');
                                                    if(arr.includes('1')){
                                                        this.$refs.variant.setTargetCountry();
                                                        this.$refs.images.setTargetCountry();
                                                    }
                                                }
                                                if (this.publishInfo.row.category != null) {
                                                    this.$refs.leimu.formData.categoryId = this.publishInfo.row.category.id
                                                    this.$refs.leimu.formData.categoryName = this.publishInfo.row.category.fullNodeNameChinese + '-' + this.publishInfo.row.category.fullNodeName
                                                }
                                                // 运输信息
                                                this.locale = resp.data.data.locale
                                                this.$refs.transport.titleList = this.selectRequired(JSON.parse(resp.data.data.propertyGroups).shipping.propertyNames)
                                                this.$refs.transport.topShuxingArr = this.handleChildren(this.$refs.transport.titleList)
                                                // 基本信息对关键字描述去除
                                                this.info = this.selectRequired(JSON.parse(resp.data.data.propertyGroups).product_details.propertyNames)
                                                for (let index = 0; index < this.info.length; index++) {
                                                    if (this.info[index].name == 'product_description') {
                                                        this.info.splice(index, 1);
                                                    } else if (this.info[index].name == 'generic_keyword') {
                                                        this.info.splice(index, 1);
                                                    }
                                                }
                                                // 变体信息-Sku
                                                this.$refs.variant.formData.Sku = item.row.sku;
                                                const propertyGroups = JSON.parse(resp.data.data.propertyGroups)
                                                const image = [];
                                                const offerPropertyNames = [];
                                                for(let i = 0; i < propertyGroups.offer.propertyNames.length; i++){
                                                    if(propertyGroups.offer.propertyNames[i].includes('image')){
                                                        image.push(propertyGroups.offer.propertyNames[i])
                                                    }else{
                                                        offerPropertyNames.push(propertyGroups.offer.propertyNames[i])
                                                    }
                                                }

                                                // let image = JSON.parse(resp.data.data.propertyGroups).offer.propertyNames

                                                // image = image.splice(image.indexOf("main_offer_image_locator"), image.length)
                                                this.$refs.variant.imageList = image

                                                this.$refs.variant.topShuxingArr = this.selectRequired(offerPropertyNames)
                                                for (let index = 0; index < this.$refs.variant.topShuxingArr.length; index++) {
                                                    if (this.$refs.variant.topShuxingArr[index].name == 'purchasable_offer') {
                                                        sessionStorage.setItem('purchasable_offer', JSON.stringify(this.$refs.variant.topShuxingArr[index]))
                                                        // this.$refs.variant.purchasable_offer = this.$refs.variant.topShuxingArr[index]
                                                        // this.$refs.variant.oldPurchasable_offer = this.$refs.variant.purchasable_offer;
                                                        this.$refs.variant.topShuxingArr.splice(index, 1)
                                                    }
                                                    // if (this.$refs.variant.topShuxingArr[index].name == 'list_price') {
                                                    //     sessionStorage.setItem('list_price', JSON.stringify(this.$refs.variant.oneTopShuxingArr[index]))
                                                    //     // this.$refs.variant.purchasable_offer = this.$refs.variant.topShuxingArr[index]
                                                    //     // this.$refs.variant.oldPurchasable_offer = this.$refs.variant.purchasable_offer;
                                                    // }
                                                    // if (this.$refs.variant.topShuxingArr[index].name == 'fulfillment_availability') {
                                                    //     sessionStorage.setItem('fulfillment_availability', JSON.stringify(this.$refs.variant.oneTopShuxingArr[index]))
                                                    //     // this.$refs.variant.purchasable_offer = this.$refs.variant.topShuxingArr[index]
                                                    //     // this.$refs.variant.oldPurchasable_offer = this.$refs.variant.purchasable_offer;
                                                    // }
                                                }
                                                this.$refs.variant.oneTopShuxingArr = this.handleChildren(this.$refs.variant.topShuxingArr)
                                                // this.$refs.variant.purchasable_offer = this.generateJsonData(this.$refs.variant.purchasable_offer)
                                                
                                                // 更多属性-各页
                                                this.$refs.attributes.infoList = this.info
                                                this.$refs.attributes.infoListShuxingArr = this.handleChildren(this.$refs.attributes.infoList)
                                                this.$refs.attributes.securityList = this.selectRequired(JSON.parse(resp.data.data.propertyGroups).safety_and_compliance.propertyNames)
                                                this.$refs.attributes.securityListShuxingArr = this.handleChildren(this.$refs.attributes.securityList)
                                                // 基本信息-产品属性
                                                this.$refs.info.product_identity = this.selectRequired(JSON.parse(resp.data.data.propertyGroups).product_identity.propertyNames)
                                                this.$refs.info.product_identity.shift()
                                                this.$refs.info.topShuxingArr = this.handleChildren(this.$refs.info.product_identity)
                                                this.setEchoInfoData()
                                                // 图片信息
                                                let isTrueEurope = JSON.parse(resp.data.data.propertyGroups).images.propertyNames.indexOf("image_locator_ps01")
                                                if (isTrueEurope != -1) {
                                                    this.isTrueEurope = isTrueEurope
                                                    this.$refs.images.imageList = JSON.parse(resp.data.data.propertyGroups).images.propertyNames.slice(0, JSON.parse(resp.data.data.propertyGroups).images.propertyNames.indexOf("image_locator_ps01"))
                                                    this.$refs.images.imageText = this.selectRequired(JSON.parse(resp.data.data.propertyGroups).images.propertyNames.slice(0, JSON.parse(resp.data.data.propertyGroups).images.propertyNames.indexOf("image_locator_ps01")))
                                                    this.$refs.images2.imageList = JSON.parse(resp.data.data.propertyGroups).images.propertyNames.slice(JSON.parse(resp.data.data.propertyGroups).images.propertyNames.indexOf("image_locator_ps01"), JSON.parse(resp.data.data.propertyGroups).images.propertyNames.length)
                                                    this.$refs.images2.imageText = this.selectRequired(JSON.parse(resp.data.data.propertyGroups).images.propertyNames.slice(JSON.parse(resp.data.data.propertyGroups).images.propertyNames.indexOf("image_locator_ps01"), JSON.parse(resp.data.data.propertyGroups).images.propertyNames.length))
                                                } else {
                                                    this.$refs.images.imageList = JSON.parse(resp.data.data.propertyGroups).images.propertyNames
                                                    this.$refs.images.imageText = this.selectRequired(JSON.parse(resp.data.data.propertyGroups).images.propertyNames)
                                                }
                                                // 回显数据1 of 2 off  
                                                if (this.$refs.variant.variantInfo != null) {
                                                    if (this.$refs.variant.variantInfo.length >= 1) {
                                                        this.$refs.variant.formData.radio = 'two'
                                                        this.$refs.variant.oldTableList = JSON.parse(this.publishInfo.row.submitJson)
                                                    }
                                                }
                                                this.$refs.variant.offerJson = JSON.parse(this.publishInfo.row.offerJson)
                                                this.$refs.variant.variantChange(this.$refs.variant.formData.radio)
                                                this.getVariantTitle()
                                                this.echoDataTransport(this.parent, this.$refs.transport.topShuxingArr, this.$refs.transport.titleList, 'length')
                                                this.echoDataTransport(this.parent, this.$refs.variant.oneTopShuxingArr, this.$refs.variant.topShuxingArr)
                                                this.echoDataTransport(this.parent, this.$refs.attributes.securityListShuxingArr, this.$refs.attributes.securityList)
                                                this.echoDataTransport(this.parent, this.$refs.attributes.infoListShuxingArr, this.$refs.attributes.infoList, 'depth')
                                                this.echoDataTransport(this.parent, this.$refs.info.topShuxingArr, this.$refs.info.product_identity)
                                                this.PlatformClassificationChange()
                                                this.setEchoImageData()
                                                this.selectTemplateList()
                                                this.dialogLoding = false
                                            })
                                        } else {
                                            this.dialogLoding = false
                                            
                                            if (this.publishInfo.row.category != null) {
                                                this.$refs.leimu.formData.categoryName = this.publishInfo.row.category.fullNodeNameChinese + '-' + this.publishInfo.row.category.fullNodeName
                                            }
                                        }
                                    } else {
                                        this.$message({
                                            type: 'error',
                                            message: res.data.message,
                                        })
                                    }
                                })
                                .catch((e) => {
                                    console.log(e)
                                })
                        } else {
                            this.dialogLoding = false
                        }
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.message,
                        })
                    }
                })
                .catch((e) => {
                    console.log(e)
                })
        }
    },
}
</script>
<style lang="scss" scoped>
.dia_box{
    max-height: 700px;
    overflow-y: auto;
}
.list-box{
    position: fixed;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1000;
    background-color: #fff;
    padding: 10px;
    border-radius: 10px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    
    .list-item{
        cursor: pointer;
        padding: 10px;
        border-radius: 10px;
        &:hover{
            background-color: #f0f0f0;
        }
        &.active{
            background-color: #e5effe;
            color: #005bf5;
        }
    }
}
.dropdown-menu {
    width: 200px;
}

.template-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.template-name {
    width: 100px;
    display: inline-block;
    text-align: justify;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.delete-btn {
    color: red;
    font-size: 16px;
    margin-left: auto;
}
.notifyBox{
    position: fixed;
    right: 0;
    top: 50%;
    background-color: #93e5f9;
    color: #000;
    padding: 10px;
    border-radius: 10px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    z-index: 1000;
    width: 530px;
    box-sizing: border-box;
    transition: all 0.3s ease-in-out;
    transition-property: transform;
    display: flex;
    align-items: center;
    padding: 20px 0;
    padding-right: 80px;
    padding-block: 0;
    .notify-content{
        width: 100%;
    }

    .notifyBox-title{
        font-size: 16px;
        font-weight: bold;
        height: 25px;
        cursor: move;
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .notifyBox-content{
        overflow-y: auto;
        max-height: 165px;
    }
    .notify-icon{
        font-size: 22px;
        width: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 10px;
        padding-left: 0 !important;
        cursor: pointer;
    }
}
</style>